import { Editor, Node, Path, Point, Range, Transforms } from 'slate';
import * as serializer from 'basic-editor-value-serializer';
import { deleteSelection } from './selection';
import { withHeaderPaste } from './paste';
import { repairHeader } from './repair';
const model = serializer.utilities.node.siteNav;

function headerEntry(editor) {
  if (!editor.selection) {
    return null;
  }
  return Editor.above(editor, { match(node) { return node.type === 'site-nav'; } });
}

function blockStart(editor, direction) {
  const block = Editor.above(editor, { match(node) { return node.type === 'paragraph' || node.type === 'button'; } });
  if (!block) {
    return false;
  }
  let point = Editor.start(editor, block[1]);
  if (direction === 'forward') {
    point = Editor.end(editor, block[1]);
  }
  return Point.equals(editor.selection.anchor, point) || Editor.string(editor, { anchor: point, focus: editor.selection.anchor }) === '';
}

function withSiteNav(editor) {
  const normalizeNode = editor.normalizeNode;
  const insertBreak = editor.insertBreak;
  const insertSoftBreak = editor.insertSoftBreak;
  const deleteBackward = editor.deleteBackward;
  const deleteForward = editor.deleteForward;
  const deleteFragment = editor.deleteFragment;
  editor.deleteFragment = function deleteHeaderFragment() {
    if (!deleteSelection(editor)) {
      deleteFragment();
    }
  };
  editor.insertBreak = function breakHeader() {
    if (headerEntry(editor)) {
      editor.insertText('\n');
      return;
    }
    insertBreak();
  };
  editor.insertSoftBreak = function softBreakHeader() {
    if (headerEntry(editor)) {
      editor.insertText('\n');
      return;
    }
    insertSoftBreak();
  };
  editor.deleteBackward = function backspaceHeader(unit) {
    if (headerEntry(editor) && Range.isCollapsed(editor.selection) && blockStart(editor, 'backward')) {
      return;
    }
    deleteBackward(unit);
  };
  editor.deleteForward = function deleteHeader(unit) {
    if (headerEntry(editor) && Range.isCollapsed(editor.selection) && blockStart(editor, 'forward')) {
      return;
    }
    deleteForward(unit);
  };
  editor.normalizeNode = function normalizeHeader(entry) {
    const node = entry[0];
    const path = entry[1];
    if (node.type === 'site-nav-region' || node.type === 'site-nav-item') {
      let blocks = false;
      for (const child of node.children) {
        blocks = blocks || typeof child.type === 'string';
      }
      if (blocks) {
        for (let index = 0; index < node.children.length; index++) {
          if (typeof node.children[index].text === 'string' && node.children[index].text === '') {
            Transforms.removeNodes(editor, { at: path.concat(index) });
            return;
          }
        }
      }
    }
    if (node.type === 'site-nav') {
      if (repairHeader(editor, path, node, model.normalizeRoot(node))) {
        return;
      }
      if (path.length === 1 && !Node.has(editor, Path.next(path))) {
        Transforms.insertNodes(editor, serializer.utilities.node.paragraph.buildNode(), { at: Path.next(path) });
        return;
      }
    }
    normalizeNode(entry);
  };
  return withHeaderPaste(editor);
}

export default withSiteNav;
